import { useContext } from 'react';
import { WorkspaceObjectBreadcrumbs } from '@/components/Workspace/ObjectBreadcrumbs';
import { useObjectBreadcrumbsContext } from '@/containers/WorkspaceObject/Context';
import { SkeletonBreadcrumbs } from '@/components/presentation/Breadcrumbs';
import styles from '@/screens/Workspace.File/style/Header.module.css';
import { FolderLoadingContext } from '@/containers/Workspace.Folder/Context';

export const FolderBreadcrumbs = () => {
  const breadcrumbs = useObjectBreadcrumbsContext();
  const isLoading = useContext(FolderLoadingContext);

  return (
    <>
      {isLoading
        ? <SkeletonBreadcrumbs />
        : (
          <div className={styles.breadcrumbs}>
            <WorkspaceObjectBreadcrumbs items={breadcrumbs} />
          </div>
        )
      }
    </>
  );
};